import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
import { OrderCardType as FoodBuyerOrderCardType } from '../../OrderList/rn';
import { Order } from '../../Order/rn';
import { Button } from '../../Button/rn';
import { useLocale } from '../../LocaleProvider/rn';
import { SELECT_ORDER_TEXT } from '../../../utils/constants';
import { Text, TouchableOpacity, View } from 'react-native';
import styles from './styles';
var prefixCls = 'food-buyer-order';
export var FoodBuyerOrder = function FoodBuyerOrder(props) {
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var shopName = props.shopName,
    orderStatusText = props.orderStatusText,
    orderId = props.orderId,
    showOrderId = props.showOrderId,
    selectAction = props.selectAction,
    selectOrderText = props.selectOrderText,
    onSelectOrder = props.onSelectOrder,
    wrapperStyle = props.wrapperStyle,
    componentTrackingData = props.componentTrackingData;
  var _useComponentTracking = useComponentTracking({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    panelOrderTracking = _useComponentTracking.result.panelOrder;
  var onOrderClick = function onOrderClick() {
    // 点击埋点
    onSelectOrder === null || onSelectOrder === void 0 ? void 0 : onSelectOrder(props);
    (panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingClick) && tracker.click(panelOrderTracking.trackingClick);
  };
  return /*#__PURE__*/React.createElement(View, {
    style: [styles[prefixCls], wrapperStyle]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles["".concat(prefixCls, "-shop")]
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles["".concat(prefixCls, "-shop__name")],
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, showOrderId ? orderId : shopName), /*#__PURE__*/React.createElement(Text, {
    style: styles["".concat(prefixCls, "-shop__type")]
  }, orderStatusText)), /*#__PURE__*/React.createElement(Order, _extends({}, props, {
    key: orderId,
    orderCardType: FoodBuyerOrderCardType.foodCardInList,
    orderStatusText: "",
    style: styles["".concat(prefixCls)]
  })), /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: styles["".concat(prefixCls, "-buttons")]
  }, /*#__PURE__*/React.createElement(Button, {
    styles: {
      containerStyle: styles["".concat(prefixCls, "-button")]
    },
    type: "primary",
    onClick: onOrderClick,
    action: selectAction,
    text: selectOrderText || trans(SELECT_ORDER_TEXT)
  })));
};